.kr{box-shadow:0 2px 8px rgba(0, 0, 0, 0.12);}